import React from 'react'
import { Helmet } from 'react-helmet'

const SeoEducationalPartners = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com/education/educational-partners' />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Educational Partners | Empowering Schools with Leading Jewelry Design Software",
            "description": "Wherever you are, find a nearby Gemvision Educational Partner. Our affiliated schools provide high-quality education, offering the best MatrixGold training to help you develop the skills needed to succeed in the jewelry design industry.",
            "item": "https://gemvision.com/education/educational-partners"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoEducationalPartners
